import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiService from '../../services/api.service'
import { createApiCase } from 'helper/create.api.case'
import { createApiThunk } from 'helper/create.api.thunk'

// The homepage strip. Answers with the car; the listing is reloaded afterwards because
// pinning changes the ORDER as well as the icon.
export const pinProduct = createApiThunk('pinProduct', apiService.pinProduct)

export const getUsedCarList = createApiThunk(
    'getUsedCarList',
    apiService.getProductList
)

export const getProductStatusCount = createApiThunk(
    'getProductStatusCount',
    apiService.getProductStatusCount
)

export const getUsedCarInfo = createApiThunk(
    'getUsedCarInfo',
    apiService.getProductInfo
)

export const createUsedCar = createApiThunk(
    'createUsedCar',
    apiService.createProduct
)

export const updateUsedCar = createApiThunk(
    'updateUsedCar',
    apiService.updateProduct
)

export const getCarPlateList = createApiThunk(
    'getCarPlateList',
    apiService.getProductList
)

export const getCarPlateInfo = createApiThunk(
    'getCarPlateInfo',
    apiService.getProductInfo
)

export const createCarPlate = createApiThunk(
    'createCarPlate',
    apiService.createProduct
)

export const updateCarPlate = createApiThunk(
    'updateCarPlate',
    apiService.updateProduct
)

export const toggleProduct = createApiThunk(
    'toggleProduct',
    apiService.toggleProduct
)

export const getBrandList = createApiThunk(
    'getBrandList',
    apiService.getBrandList
)

export const getModelList = createApiThunk(
    'getModelList',
    apiService.getModelList
)

// export const updateService = createAsyncThunk(
//     'updateService',
//     async (payload, thunkAPI) => {
//         try {
//             const response = await apiService.updateService(payload)
//             return response
//         } catch (error) {
//             return thunkAPI.rejectWithValue(error)
//         }
//     }
// )

export const initialData = {
    // One number per inventory tab, off the endpoint that also filters the listing.
    productTabCounts: {},
    // toggleLoading: false,
    // packageToggle: false,
    // toggle: false,

    productSort: {
        active_page: 1,
        start: 0,
        length: 10,
        search: '',
        toggle_loading: false,
        // The inventory tab. Go-live is where a car starts its life on sale, so that
        // is what opens.
        type: 'go_live',
        // Empty means the backend's own order: priority, then newest.
        sort: '',
        order: '',
    },

    usedCarData: {
        list: [],
        total: 0,
        loading: false,
    },
    usedCarInfo: {},
    carPlateData: {
        list: [],
        total: 0,
        loading: false,
    },
    carPlateInfo: {},

    brandList: [],
    modelList: [],

    formLoading: false,
    updateLoading: false,
    createLoading: false,
}

const dataSlice = createSlice({
    name: 'product/data',
    initialState: initialData,
    reducers: {
        setProductSort: (state, action) => {
            state.productSort = action.payload
        },
        clearProductSort: (state, action) => {
            state.productSort = {
                active_page: 1,
                start: 0,
                length: 10,
                search: '',
                toggle_loading: false,
                sort: '',
                order: '',
            }
        },
    },
    extraReducers: (builder) => {
        createApiCase(builder, getProductStatusCount, {
            fulfilled: (state, action) => {
                state.productTabCounts = action.payload.data?.tab_counts || {}
            },
        })
        createApiCase(builder, getUsedCarInfo, {
            loading: 'formLoading',
            fulfilled: (state, action) => {
                state.usedCarInfo = action.payload.data
            },
        })
        createApiCase(builder, createUsedCar, {
            loading: 'formLoading',
        })
        createApiCase(builder, updateUsedCar, {
            loading: 'formLoading',
        })

        createApiCase(builder, getCarPlateInfo, {
            loading: 'formLoading',
            fulfilled: (state, action) => {
                state.carPlateInfo = action.payload.data
            },
        })
        createApiCase(builder, createCarPlate, {
            loading: 'formLoading',
        })
        createApiCase(builder, updateCarPlate, {
            loading: 'formLoading',
        })
        createApiCase(builder, getBrandList, {
            loading: 'listLoading',
            fulfilled: (state, action) => {
                state.brandList = action.payload.data.aaData
            },
        })
        createApiCase(builder, getModelList, {
            loading: 'listLoading',
            fulfilled: (state, action) => {
                state.modelList = action.payload.data.aaData
            },
        })
        builder
            .addCase(getUsedCarList.pending, (state) => {
                state.usedCarData.loading = true
                state.productSort.toggle_loading = false
            })
            .addCase(getUsedCarList.fulfilled, (state, action) => {
                state.usedCarData.loading = false
                state.productSort.toggle_loading = false

                state.usedCarData.list = action.payload.data.aaData
                state.usedCarData.total =
                    action.payload.data.iTotalDisplayRecords
            })
            .addCase(getUsedCarList.rejected, (state) => {
                state.usedCarData.loading = false
                state.productSort.toggle_loading = false
            })

            .addCase(getCarPlateList.pending, (state) => {
                state.carPlateData.loading = true
                state.productSort.toggle_loading = false
            })
            .addCase(getCarPlateList.fulfilled, (state, action) => {
                state.carPlateData.loading = false
                state.productSort.toggle_loading = false

                state.carPlateData.list = action.payload.data.aaData
                state.carPlateData.total =
                    action.payload.data.iTotalDisplayRecords
            })
            .addCase(getCarPlateList.rejected, (state) => {
                state.carPlateData.loading = false
                state.productSort.toggle_loading = false
            })

            .addCase(toggleProduct.pending, (state) => {
                state.usedCarData.loading = true
                state.carPlateData.loading = true

                state.productSort.toggle_loading = true
            })
            .addCase(toggleProduct.fulfilled, (state, action) => {
                state.usedCarData.loading = true
                state.carPlateData.loading = true

                state.productSort.toggle_loading = false
            })
            .addCase(toggleProduct.rejected, (state) => {
                state.usedCarData.loading = false
                state.carPlateData.loading = true

                state.productSort.toggle_loading = false
            })
    },
})

export const { setProductSort, clearProductSort } = dataSlice.actions

export default dataSlice.reducer
